import { makeStyles } from "@mui/styles";
import { COLORS } from "components/v3/Theme/colors";

const ResourceLinkStyles = makeStyles((theme) => ({
  link: {
    color: COLORS.DARK_GRAY_2,
    textDecoration: "none",
    fontWeight: 600,
    fontSize: "1.125rem",
    lineHeight: "1.25rem",
    display: "block",
    marginBottom: 10,
    "&:hover": {
      textDecoration: "underline"
    }
  }
}));

export default ResourceLinkStyles;
